var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var InfoTip = require("../components/info-tip.jsx");
var NumberInput = require("../components/number-input.jsx");
var TextInput = require("../components/text-input.jsx");

var PassageRefEditor = React.createClass({
    displayName: "PassageRefEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        passageNumber: React.PropTypes.number,
        referenceNumber: React.PropTypes.number,
        summaryText: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            passageNumber: 1,
            referenceNumber: 1,
            summaryText: ""
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Passage Number: ",
                    React.createElement(NumberInput, {
                        value: this.props.passageNumber,
                        onChange: this.change("passageNumber")
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Reference Number: ",
                    React.createElement(NumberInput, {
                        value: this.props.referenceNumber,
                        onChange: this.change("referenceNumber")
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Summary Text: ",
                    React.createElement(TextInput, {
                        value: this.props.summaryText,
                        onChange: this.change("summaryText")
                    }),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "Short summary of the referenced section. This will be included in parentheses and quotes automatically."
                        ),
                        React.createElement(
                            "p",
                            null,
                            "Ex: The start ... the end"
                        )
                    )
                )
            )
        );
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = PassageRefEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/passage-ref-editor.jsx
 ** module id = 137
 ** module chunks = 0 1
 **/